import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Bookmark({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'16px'} height={'20px'} viewBox={'0 0 16 20'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-4.000000, -2.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M18,19.0568107 L18,5 C18,4.44771525 17.5522847,4 17,4 L7,4 C6.44771525,4 6,4.44771525 6,5 L6,19.0568107 L11.4187618,15.1862665 C11.7664593,14.9379112 12.2335407,14.9379112 12.5812382,15.1862665 L18,19.0568107 Z M5.58123819,21.8137335 C4.91936972,22.2864967 4,21.8133726 4,21 L4,5 C4,3.34314575 5.34314575,2 7,2 L17,2 C18.6568542,2 20,3.34314575 20,5 L20,21 C20,21.8133726 19.0806303,22.2864967 18.4187618,21.8137335 L12,17.2289036 L5.58123819,21.8137335 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Bookmark.propTypes = {
  className: PropTypes.string,
}
